import { useState } from 'react';

interface EditableFieldProps {
  value: string | number;
  onSave: (value: string | number) => void;
  type?: 'text' | 'number';
  placeholder?: string;
  className?: string;
  prefix?: string;
}

export const EditableField = ({ 
  value, 
  onSave, 
  type = 'text', 
  placeholder, 
  className = '',
  prefix = ''
}: EditableFieldProps) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editValue, setEditValue] = useState(value?.toString() || '');

  const handleEdit = () => {
    setEditValue(value?.toString() || '');
    setIsEditing(true);
  };

  const handleSave = () => {
    const newValue = type === 'number' ? parseFloat(editValue) : editValue;
    onSave(newValue);
    setIsEditing(false);
  };

  const handleCancel = () => {
    setEditValue(value?.toString() || '');
    setIsEditing(false);
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSave();
    } else if (e.key === 'Escape') {
      handleCancel();
    }
  };

  if (isEditing) {
    return (
      <div className="editable-field editing">
        <input
          type={type}
          value={editValue}
          onChange={(e) => setEditValue(e.target.value)}
          onKeyDown={handleKeyPress}
          onBlur={handleSave}
          placeholder={placeholder}
          className="editable-input"
          autoFocus
        />
      </div>
    );
  }

  return (
    <div className={`editable-field ${className}`} onClick={handleEdit}>
      <span className="editable-value">
        {prefix}{value || placeholder || 'Click to edit'}
      </span>
      <span className="edit-icon">✏️</span>
    </div>
  );
};